module.exports = __webpack_public_path__ + "assets/01e578c37618385e1064f101c0cd8360.svg";